import {Component} from "@angular/core";
import {MixAndMatchSearchModel} from "../mix-and-match-search.model";
import {MixAndMatchEntityModel} from "../mix-and-match-entity.model";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";

@Component({
    selector: "wbo-mix-and-match-search-page",
    templateUrl: "./mix-and-match-search-page.component.html",
    providers: [provideSearchModel(MixAndMatchSearchModel), provideEntityModel(MixAndMatchEntityModel)]
})
export class MixAndMatchSearchPageComponent extends AbstractSearchPage {
    constructor() {
        super();
    }
}
